import { NavKeys } from '@common-modules/dependencies/navigation/nav-keys.enum';
import { AppNavigationsSettings } from '@common-modules/navigation/models/app-navigations-settings';
import { MenuLinkConf } from '@common-modules/navigation/models/menu-link-conf';
import { ModuleLinkConf } from '@common-modules/navigation/models/module-link-conf';
import { CtNavKeys } from './navigation/ct-nav-keys';

const T_SCOPE = 'navigations.titles';

const links: Map<NavKeys, MenuLinkConf | ModuleLinkConf> = new Map<
  NavKeys,
  MenuLinkConf | ModuleLinkConf
>([
  [
    CtNavKeys.Home,
    new MenuLinkConf({
      urlPath: '',
    }),
  ],
  [
    CtNavKeys.Workspaces,
    new MenuLinkConf({
      titleTranslateKey: `${T_SCOPE}.workspaces`,
      svgIcon: 'ct-workspaces',
      urlPath: '/workspaces',
      standalone: true,
    }),
  ],
  [
    CtNavKeys.ModelVersions,
    new MenuLinkConf({
      titleTranslateKey: `${T_SCOPE}.model-versions`,
      svgIcon: 'ct-model-management',
      urlPath: '/model-versions',
      standalone: true,
    }),
  ],
  [
    CtNavKeys.Measurements,
    new MenuLinkConf({
      titleTranslateKey: `${T_SCOPE}.telemetry`,
      svgIcon: 'ct-measurements',
      urlPath: '/measurements',
      standalone: true,
    }),
  ],
  [
    CtNavKeys.Map,
    new MenuLinkConf({
      titleTranslateKey: `${T_SCOPE}.map`,
      svgIcon: 'ct-map',
      urlPath: '/map',
      standalone: true,
    }),
  ],
  [
    CtNavKeys.AdministrationModule,
    new ModuleLinkConf({
      titleTranslateKey: `${T_SCOPE}.administration`,
      svgIcon: 'administration_group',
      menuLinksKeys: [CtNavKeys.Users, CtNavKeys.Groups],
    }),
  ],
  [
    CtNavKeys.Users,
    new MenuLinkConf({
      titleTranslateKey: `${T_SCOPE}.users`,
      svgIcon: 'ct-users',
      urlPath: '/security/users',
    }),
  ],
  [
    CtNavKeys.Groups,
    new MenuLinkConf({
      titleTranslateKey: `${T_SCOPE}.groups`,
      svgIcon: 'ct-groups',
      urlPath: '/security/groups',
    }),
  ],
]);

export const cloudTwinAppNavigations: AppNavigationsSettings = {
  moduleLinkKeys: [CtNavKeys.AdministrationModule],
  hiddenLinks: new Map<NavKeys, MenuLinkConf>(),
  links,
};
